module.exports = __webpack_public_path__ + "img/add_green.b9b6d26a.svg";